import { toastError } from '@devrangex/rui'
import styled from '@emotion/styled'
import * as Sentry from '@sentry/react'
import { AxiosError } from 'axios'
import { Cookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'

import logo from '../assets/logo.svg'
import useLogin from '../components/hooks/useLogin'
import LoginForm from '../components/login/LoginForm'
import { PageLayout } from '../styles/layouts'


const StyledLoginPage = styled.div`
    max-width: 475px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 22vh;
    gap: 60px;
    img {
    }

    h1 {
        ${({theme}) => theme.font.heading1}
    }
`

const Version = styled.p`
    ${({theme: {font}}) => font.subheading}
    color: ${({theme}) => theme.pallete.gray[900]};
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 72px;
`

export default function LoginPage() {
  const navigate = useNavigate()

  const {isLoading, mutate: login} = useLogin({
    onSuccess: (tokens) => {
      const cookies = new Cookies()

      cookies.set('accessToken', tokens.accessToken)
      cookies.set('refreshToken', tokens.refreshToken)

      navigate('/', {replace: true})
    },
    onError: (errors) => {
      let message = ''

      if (errors instanceof AxiosError) {
        message = errors.response?.data.message
      }

      toastError(message, {isKiosk: true})

      Sentry.captureException(errors)
    },
  })

  return (
    <PageLayout>
      <StyledLoginPage>
        <img src={logo} alt="rangex logo"/>
        <h1>스마트 로그인</h1>

        <LoginForm onSubmit={login} isLoading={isLoading}/>
      </StyledLoginPage>

      <Version>{import.meta.env.VITE_DEPLOY_VERSION}</Version>
    </PageLayout>
  )
}
